// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"231":"feed","263":"widget","791":"video"}[chunkId] + "." + {"231":"1cb02b079dfb14d49609","263":"f91f6529fd5a5256ff4a","791":"976795afa20ead421d9c"}[chunkId] + ".js";
};